var e={exports:{}};export{e as __module};
//# sourceMappingURL=updateLocale.js.map
